function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.121 38.121l37-36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.121 38.121l-37-36"
}));

function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.242 40.242"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MS4yNDIgNDAuMjQyIj4KICA8ZyBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiPgogICAgPHBhdGggZD0iTTIuMTIxIDM4LjEyMWwzNy0zNiIvPgogICAgPHBhdGggZD0iTTM5LjEyMSAzOC4xMjFsLTM3LTM2Ii8+CiAgPC9nPgo8L3N2Zz4=";
export { SvgX as ReactComponent };